"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
const flatbuffers = require("flatbuffers");
class MosaicLevy {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMosaicLevy(bb, obj) {
        return (obj || new MosaicLevy()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMosaicLevy(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new MosaicLevy()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    recipient(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    recipientLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    recipientArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    mosaicId(index) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    mosaicIdLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    mosaicIdArray() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    fee(index) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    feeLength() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    feeArray() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    static startMosaicLevy(builder) {
        builder.startObject(4);
    }
    static addType(builder, type) {
        builder.addFieldInt8(0, type, 0);
    }
    static addRecipient(builder, recipientOffset) {
        builder.addFieldOffset(1, recipientOffset, 0);
    }
    static createRecipientVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startRecipientVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addMosaicId(builder, mosaicIdOffset) {
        builder.addFieldOffset(2, mosaicIdOffset, 0);
    }
    static createMosaicIdVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startMosaicIdVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addFee(builder, feeOffset) {
        builder.addFieldOffset(3, feeOffset, 0);
    }
    static createFeeVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startFeeVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endMosaicLevy(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createMosaicLevy(builder, type, recipientOffset, mosaicIdOffset, feeOffset) {
        MosaicLevy.startMosaicLevy(builder);
        MosaicLevy.addType(builder, type);
        MosaicLevy.addRecipient(builder, recipientOffset);
        MosaicLevy.addMosaicId(builder, mosaicIdOffset);
        MosaicLevy.addFee(builder, feeOffset);
        return MosaicLevy.endMosaicLevy(builder);
    }
}
exports.MosaicLevy = MosaicLevy;
//# sourceMappingURL=MosaicLevyBuffer.js.map